import { render } from "./App.vue?vue&type=template&id=06290555"
const script = {}

import "./App.vue?vue&type=style&index=0&id=06290555&lang=css"
script.render = render

export default script